module.exports = __webpack_public_path__ + "static/media/gebauer_rairigh.6aeaeb12.jpg";